export enum DiscountType {
  PRICE_DROP = "PriceDrop",
  CARROT_CASH = "CarrotCash",
  CHFAR_REDEMPTION = "ChfarRedemption",
}

export enum TagType {
  Algomerch = "algomerch",
}

export enum AlgomerchTag {
  BestFlight = "BestFlight",
  Cheapest = "Cheapest",
  BestQuality = "BestQuality",
  Fastest = "Fastest",
}

export type TagValue = AlgomerchTag;
